import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {PlusIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import router from "@/routing/Router";


const FeaturedProductsHeadingActions = () => {
    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"primary"}
                iconBefore={<Icon icon={PlusIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {to: router.newFeaturedProduct.absolutePath()}
                }}
            >
                <FormattedMessage id={"newFeaturedProduct"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default FeaturedProductsHeadingActions;